import { Stack, List, Grid, Typography, Link, Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import SendIcon from "@mui/icons-material/Send";
import FacebookIcon from "@mui/icons-material/Facebook";
import GoogleIcon from "@mui/icons-material/Google";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

import headerConstants from "../../utils/headerConstant.json";
import { useState } from "react";

interface Props {
  phone: number;
  email1: string;
  email2: string;
  email3: string;
  address: string;
}

interface ILink {
  link: string;
  path: string;
}

const Footer = () => {
  const [headers, setHeaders] = useState<Props>(headerConstants.headers);

  const footerLinks: Array<ILink> = [
    { link: "Home", path: "/" },
    { link: "About Us", path: "/about/about" },
    { link: "Course", path: "/courses/bachelor-of-physiotherapy" },
    { link: "Student", path: "/students-corner/student-council" },
    { link: "Academics", path: "/academics/academic-scehdules" },
    { link: "Admission", path: "/admission/admission-procedure-BPT" },
    { link: "Infrastructure", path: "/facilities/infrastructure" },
    { link: "Contact Us", path: "/contact" },
  ];

  const policyLinks: Array<ILink> = [
    { link: "Legal Disclaimer", path: "/policies/legalDisclaimer" },
    { link: "Copyright Policy", path: "/policies/CopyRightPolicy" },
    { link: "Hyperlinking Policy", path: "/policies/hyperLinkingPolicy" },
    { link: "Privacy Policy", path: "/policies/privacyPolicy" },
    { link: "Terms & Conditions", path: "/policies/Conditions" },
    { link: "Cancellation & Refund Policy", path: "/policies/Cancellations" },
  ];

  return (
    <Stack
      direction="column"
      sx={{
        backgroundColor: "primary.main",
        p: { xs: 2, md: 2 },
        color: "white",
        textAlign: "left",
        gap: { xs: 2, md: 3 },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            About Us
          </Typography>
          <Typography variant="body2" mb={2} fontSize="small">
            Progressive Education Society was established in 1934 by an eminent
            educationist Prof. S. R. Kanitkar and is known for its academic
            excellence.
          </Typography>
          <Stack direction="row" spacing={1}>
            <FacebookIcon fontSize="small" />
            <GoogleIcon fontSize="small" />
            <TwitterIcon fontSize="small" />
            <LinkedInIcon fontSize="small" />
          </Stack>
        </Grid>

        <Grid item xs={6} md={3}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Featured Links
          </Typography>
          <Grid container spacing={0.5}>
            <Grid item xs={12} sm={6}>
              <List disablePadding>
                {footerLinks.slice(0, 4).map((value) => (
                  <Box
                    key={value.link}
                    display="flex"
                    alignItems="center"
                    mb={0.5}
                  >
                    <ArrowForwardIosIcon
                      fontSize="small"
                      sx={{ mr: 0.5, color: "text.secondary" }}
                    />
                    <Link href={value.path} underline="hover" color="inherit">
                      <Typography variant="body2" fontSize="small">
                        {value.link}
                      </Typography>
                    </Link>
                  </Box>
                ))}
              </List>
            </Grid>
            <Grid item xs={12} sm={6}>
              <List disablePadding>
                {footerLinks.slice(4).map((value) => (
                  <Box
                    key={value.link}
                    display="flex"
                    alignItems="center"
                    mb={0.5}
                  >
                    <ArrowForwardIosIcon
                      fontSize="small"
                      sx={{ mr: 0.5, color: "text.secondary" }}
                    />
                    <Link href={value.path} underline="hover" color="inherit">
                      <Typography variant="body2" fontSize="small">
                        {value.link}
                      </Typography>
                    </Link>
                  </Box>
                ))}
              </List>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6} md={3}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Policy
          </Typography>
          <List disablePadding>
            {policyLinks.map((value) => (
              <Box key={value.link} display="flex" alignItems="center" mb={0.5}>
                <ArrowForwardIosIcon
                  fontSize="small"
                  sx={{ mr: 0.5, color: "text.secondary" }}
                />
                <Link href={value.path} underline="hover" color="inherit">
                  <Typography variant="body2" fontSize="small">
                    {value.link}
                  </Typography>
                </Link>
              </Box>
            ))}
          </List>
        </Grid>

        <Grid item xs={12} md={2.5}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Get In Touch
          </Typography>
          <Box mb={0.5} display="flex" alignItems="start">
            <LocationOnIcon
              fontSize="small"
              sx={{ mr: 0.5, color: "text.secondary" }}
            />
            <Typography variant="body2" fontSize="small">
              {headers.address}
            </Typography>
          </Box>
          <Box mb={0.5} display="flex" alignItems="center">
            <CallIcon
              fontSize="small"
              sx={{ mr: 0.5, color: "text.secondary" }}
            />
            <Typography variant="body2" fontSize="small">
              +91 {headers.phone}
            </Typography>
          </Box>
          <Box mb={0.5} display="flex" alignItems="center">
            <SendIcon
              fontSize="small"
              sx={{ mr: 0.5, color: "text.secondary" }}
            />
            <Typography variant="body2" fontSize="small">
              {headers.email1}
            </Typography>
          </Box>
          <Box mb={0.5} display="flex" alignItems="center">
            <SendIcon
              fontSize="small"
              sx={{ mr: 0.5, color: "text.secondary" }}
            />
            <Typography variant="body2" fontSize="small">
              {headers.email3}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Footer;
